import React, { Component } from 'react'
import { withRouter } from 'react-router'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import PasswordResetStep1UI from './PasswordResetStep1UI.js'

class PasswordResetStep1SF extends Component {
  constructor(props) {
    super(props)
    let params = new URLSearchParams(window.location.search)
    this.state = {
      errorList: [],
      submitted: false,
      // email
      email: params.has('identity') ? params.get('identity') : '',
      emailError: null,
    }
  }

  render() {
    return (
      <PasswordResetStep1UI
        context={this.props.context}
        messageList={this.props.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={(errorList) => {this.setState({errorList: errorList})}}
        // email
        email={this.state.email}
        emailError={this.state.emailError}
        onEmailChange={(event) => {this.setState({email: event.target.value})}}
        setEmailError={(error) => {this.setState({emailError: error})}}
      />
    )
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    this.setState({submitted: true})

    RestApiUtils.post(this.props.context,
      '/api/pub/passwordReset',
      this.onPasswordResetStep1Callback, {
        email: this.state.email,
      }
    )
  }

  onPasswordResetStep1Callback = (response) => {
    let errorList = []
    this.setState({submitted: false})

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'email':
            this.setState({emailError: error.message})
            break;
          default:
        }
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList
    })

    if (errorList.length === 0) {
      setTimeout(() => {
        this.props.history.push(`/pub/password-reset?identity=${this.state.email}`)
      }, 2000);
    }
  }
}

export default withRouter(PasswordResetStep1SF)
